import React, {useEffect, useState} from 'react'
import {useError} from "../../hooks/useError";
import {FaCaretDown, FaCaretUp, FaCheck, FaLock, FaPencilAlt} from "react-icons/fa";
import {LuAxe, LuBookmark, LuNotebookText} from "react-icons/lu";
import {Link, useOutletContext, useParams} from "react-router-dom";
import {routes} from "../../utils/Routes";
import {ImPencil2} from "react-icons/im";
import {convertIcon} from "../../utils/DynamicContentUtils";
import {getCourseNavigation, getCourseNavigationPreview} from "../../services/CourseRepository";

export function ChapterNavigationBar({initSelectedModule, preview, courseId}) {
    const [selectedModule, setSelectedModule] = useState(null)
    const [courseNavigation, setCourseNavigation] = useState([]);
    const params = useParams();
    const {setErrorMessage} = useError();

    useEffect(() => {

        if (!preview) {
            getCourseNavigation(courseId, setErrorMessage).then(response => setCourseNavigation(response))
        } else {
            getCourseNavigationPreview(courseId, setErrorMessage).then(response => setCourseNavigation(response))
        }

        if (courseNavigation != null && courseNavigation.length > 0) {

            if (initSelectedModule != null) {
                setSelectedModule(initSelectedModule)
            } else {
                setSelectedModule(courseNavigation[0])
            }

        }
    }, []);

    function getChapterIcon(chapterType) {
        switch (chapterType) {
            default:
            case "COURSE":
                return <LuNotebookText size={24} className={"me-2"}/>
            case "EXAM":
                return <FaPencilAlt size={24} className={"me-2"}/>
        }
    }

    function isSelected(module) {
        if (selectedModule == null) {
            return false;
        }
        return (selectedModule.hasOwnProperty("id") && selectedModule.id === module.moduleId) || (selectedModule.hasOwnProperty("moduleId") && selectedModule.moduleId === module.moduleId);
    }

    return (
        <table className={"course-nav "}>
            <tbody>
            {
                courseNavigation.map(module => (
                    <>
                        <tr onClick={() => {
                            if (isSelected(module)) {
                                setSelectedModule(null)
                            } else {
                                setSelectedModule(module)
                            }
                        }}>
                            <td className={"module-nav d-flex flex-column m-0  " + (isSelected(module) ? " active " : "")}>
                                <div className={"row  module-nav-header ps-3"}>
                                    <div className={"col-1"}>
                                        {convertIcon(module.icon, 24)}
                                    </div>
                                    <div className={"col"}>
                                        <Link to={routes.chapterPageAbs(params.productName, courseId, module.moduleName, null, true)}
                                              className={" text-decoration-none"}>
                                           <p className={"p-0 ms-2"}>{module.moduleName}</p>
                                        </Link>
                                    </div>

                                    <div className={"col-3 d-flex  justify-content-center "}>
                                        {
                                            isSelected(module) ?
                                                <FaCaretUp size={20}/>
                                                :
                                                <FaCaretDown size={20} className={"text-muted"}/>
                                        }
                                    </div>

                                </div>

                                {
                                    isSelected(module) ? module.chapters.slice(1).map((chapter, idx) => (
                                        <div
                                            className={"m-0 chapter-nav py-2 " + (isSelected(module) ? " active" : "")}>
                                            <div className={"d-flex ps-5"}>
                                                <Link
                                                    to={routes.coursePageAbs(params.productName, courseId, module.moduleName, chapter.moduleChapterName, chapter.modulePage, preview)}
                                                    className=" clickable text-dark text-decoration-none m-0 ">

                                                    {preview && !chapter.unlocked ? <FaLock size={18} className={"me-2 text-muted"}/> : null}

                                                    <label>{chapter.moduleChapterName}</label>
                                                </Link>
                                            </div>
                                        </div>
                                    )) : null
                                }
                            </td>
                        </tr>
                    </>
                ))
            }
            </tbody>
        </table>
    );
}